import React, { ReactElement } from 'react';
import PanelMain from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Main';
import usePanelMainContainer from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/Panel/Main/usePanelMain';

const PanelMainContainer = (): ReactElement => {
    const { data, onWidgetSelect, isLoading, error, tryAgain, onFeaturePresetSelect, branding } = usePanelMainContainer();
    return (
        <PanelMain
            errorAction={tryAgain}
            error={error}
            isLoading={isLoading}
            branding={branding}
            data={data}
            onWidgetClick={onWidgetSelect}
            onFeaturePresetClick={onFeaturePresetSelect}
        />
    );
};

export default PanelMainContainer;
